<template>
  <Transition name="modal-fade">
    <div v-if="modelValue" class="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center overflow-hidden! !z-[9999]"
      @click="handleOverlayClick" @touchmove.stop @wheel.stop>

      <div class="bg-form-box rounded-2xl shadow-xl overflow-hidden! w-full mx-4 relative" :class="[
        size === 'sm' ? 'max-w-sm' :
          size === 'md' ? 'max-w-md h-[290px]' :
            size === 'lg' ? 'max-w-lg' :
              size === 'xl' ? 'max-w-[950px] h-[min(760px,calc(100dvh_-_6rem))] flex flex-col' :
                'max-w-full ',
        size === 'userDetail' ? 'flex flex-col !max-w-[1500px] !min-w-[1000px] !h-[710px]' : '',
        size === 'managmentDemand' ? '!max-w-[900px] !min-h-[110px] !max-h-[320px]' : '',
        size === 'pageBuilder' ? '!w-[950px] !h-[480px] ' : '',
        size === 'pagesOptions' ? '!w-[790px] !overflow-hidden' : '',
        size === 'logout' ? '!w-[420px] !h-[145px]' : '',
        isIconModal ? 'max-h-[500px]' : ''
      ]" @click.stop role="dialog" aria-modal="true">

        <!-- Header -->
        <slot name="icon" />
        <div v-if="$slots.header || title" class="px-6 pt-4">
          <slot name="header" />
        </div>

        <!-- for props title -->
        <div v-if="title" class="px-6 py-2">
          <h3 class="text-[20px] leading-[34px] text-font-dark "
            :class="[isBold ? 'font-ExtraBold' : 'font-mediumm', showOtpInput ? 'text-center' : '']">
            {{ title }}
          </h3>
        </div>

        <!-- modalDetails title -->
        <div v-if="modalDetails?.title" class="px-6 pt-4">
          <h3 class="text-[20px] leading-[34px] text-font-dark "
            :class="[isBold ? 'font-ExtraBold' : 'font-mediumm', showOtpInput ? 'text-center' : '']">
            {{ modalDetails?.title }}
          </h3>
        </div>

        <!-- slot body -->
        <div class="px-6 h-full flex-1 min-h-0 overflow-y-auto">
          <slot name="body" />
        </div>

        <!-- Body -->
        <div class="px-4 py-2">
          <slot name="body-top" />

          <div v-if="showInput" class="space-y-4">
            <label v-if="inputLabel" :for="inputId" class="block text-sm font-medium text-gray-700">
              {{ inputLabel }}
            </label>

            <div class="relative">
              <form @submit.prevent="submitHandler" class="space-y-4">
                <div class="flex flex-col gap-1">
                  <input ref="inputRef" :id="inputId" v-model="inputValue" :type="inputType" :placeholder="placeholder"
                    :maxlength="maxLength" :disabled="disabled" :class="[
                      'w-full px-4 bg-gray-100 py-2 border rounded-full shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500',
                      showError ? 'border-red-500' : 'border-gray-300',

                    ]" @input="handleInput" />
                  <!-- Error message  -->
                  <div v-if="showError && errorMessage" class="text-red-500 text-[12px] text-right px-2">
                    {{ errorMessage }}
                  </div>
                </div>
                <div class="flex flex-nowrap items-center gap-2 pb-3" dir="rtl">
                  <BaseButton type="submit" :is-icon-only="false" :is-circle="true" variant="orange"
                    class-name="flex-1 py-[13px]" :is-loading="isLoading" :disabled="disabled || showError">
                    {{ t('fileManager.modalCreateFolder.confirm') }}
                  </BaseButton>
                  <BaseButton type="button" :is-icon-only="false" :is-circle="true" variant="outlines"
                    class-name="flex-1 py-[13px]" @click="closeModal">
                    {{ t('fileManager.modalCreateFolder.cancel') }}
                  </BaseButton>
                </div>
              </form>
            </div>
          </div>
          <div v-if="isShowDeleteItem" class="flex flex-nowrap gap-3 mt-3 pb-3" dir="rtl">
            <BaseButton variant="red" class-name="flex-1 py-[13px]" :is-circle="true" :is-icon-only="false"
              @click="deleteHandler" :is-loading="isLoading">
              {{ t('fileManager.modalDelete.yesDelete') }}
            </BaseButton>
            <BaseButton variant="outlines" class-name="flex-1 py-[13px]" :is-circle="true" :is-icon-only="false"
              @click="closeModal">
              {{ t('fileManager.modalDelete.noDelete') }}
            </BaseButton>
          </div>
          <div v-if="showOtpInput" class="w-full">
            <form @submit.prevent="handleFormSubmit"
              class="w-full flex flex-col items-center justify-center gap-4 mt-3 mb-2">

              <div class="w-full flex flex-col items-center justify-center gap-3">
                <IconShieldLock color="#000" size="54" />
                <p class="text-[16px] leading-[20px] text-font-dark font-demiboldd">
                  ورود کد دو مرحله ای
                </p>
              </div>

              <OtpInput v-model="displayValue" dir="ltr" :num-inputs="6" :should-auto-focus="true" :is-input-num="true"
                :is-input-secure="false" :should-focus="true" :placeholder="['0', '0', '0', '0', '0', '0']"
                :separator="' '" input-classes="otp-input" container-classes="otp-container" @on-change="handleInput"
                @on-complete="handleComplete" :should-auto-advance="true" :should-focus-first="true"
                autocomplete="one-time-code" inputmode="numeric" pattern="[0-9۰-۹]*" :should-paste="true"
                :should-clear="true" :disabled="isLoading" />

              <BaseButton type="submit" :is-icon-only="false" :is-circle="true" :style="{ backgroundColor: BASE_COLOR }"
                class-name="flex-1 w-full py-[13px]" :is-loading="isLoading"
                :disabled="disabled || showError || displayValue.length !== 6 || isLoading">
                {{ isLoading ? 'در حال بررسی...' : 'ارسال کد' }}
              </BaseButton>
            </form>
          </div>
          <div v-if="modalDetails.body || modalDetails.btnCancel && modalDetails.btnOk"
            class="w-full flex flex-col gap-7 py-2">
            <p class="text-[14px] text-[#000000]">
              {{ modalDetails.body }}
            </p>
            <div class="w-full flex items-center gap-2">
              <BaseButton :is-icon-only="false" :is-circle="true" variant="base" class-name="flex-1 py-[13px]"
                :isLoading="isLoading" @click="submitModalConfirm">
                {{ modalDetails.btnOk }}
              </BaseButton>
              <BaseButton :is-icon-only="false" :is-circle="true" variant="outlines" class-name="flex-1 py-[13px]"
                @click="closeModal">
                {{ modalDetails.btnCancel }}
              </BaseButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, watch, onMounted, computed } from 'vue'
import BaseButton from '@/components/base/BaseButton.vue'
import { useI18n } from 'vue-i18n'
import { useLocale } from '@/composables/useLocale'
import OtpInput from 'vue3-otp-input'
import { IconShieldLock } from '@tabler/icons-vue';
import type { Modal } from '@/types/report'

// interface

interface Props extends BaseModalProps {
  showInput?: boolean
  inputLabel?: string
  inputType?: string
  placeholder?: string
  maxLength?: number
  showCharCount?: boolean
  displayText?: string
  disabled?: boolean
  errorMessage?: string
  showError?: boolean
  defaultValue?: string
  isShowDeleteItem?: boolean
  isLoading?: boolean
  showOtpInput?: boolean
  isIconModal?: boolean
  modalDetail?: Modal
  id?: number
}

interface BaseModalProps {
  modelValue: boolean
  title?: string
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full' | 'userDetail' | 'managmentDemand' | 'pageBuilder' | 'pagesOptions' | 'logout'
  className?: string
  showCloseButton?: boolean
  closeOnOverlayClick?: boolean
  preventScroll?: boolean
  isBold?: boolean
}


// props

const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
  title: '',
  size: 'md',
  className: '',
  showCloseButton: true,
  closeOnOverlayClick: true,
  preventScroll: true,
  showInput: false,
  inputType: 'text',
  placeholder: '',
  maxLength: undefined,
  showCharCount: false,
  displayText: '',
  disabled: false,
  errorMessage: '',
  showError: false,
  defaultValue: '',
  isShowDeleteItem: false,
  isBold: false,
  isIconModal: false,
})

// emits

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'close'): void
  (e: 'input', value: string): void
  (e: 'submit', value: string): void
  (e: 'deleteFolder'): void
  (e: 'complete', value: string): void
  (e: 'submitModalConfirm'): void
}>()

// vars

const inputId = `modal-input-${Math.random().toString(36).substr(2, 9)}`
const inputValue = ref(props.defaultValue)
const isClosing = ref(false)
const displayValue = ref('')
const inputRef = ref<HTMLInputElement | null>(null)
const { t } = useI18n()
const { locale: local } = useLocale()
const { BASE_COLOR } = CONFIG

// life cycle hooks

onMounted(() => {
  if (props.showInput) {
    inputRef.value?.focus()
  }
})

// computed

const modalDetails = computed(() => {
  if (props.modalDetail) {
    return {
      title: props.modalDetail?.title,
      body: props.modalDetail?.body,
      btnCancel: props.modalDetail?.cancel_text,
      btnOk: props.modalDetail?.ok_text
    }
  }
  return {}
})

// methods

const closeModal = () => {
  isClosing.value = true
  emit('update:modelValue', false)
  emit('close')
  inputValue.value = props.defaultValue || ''
}

const handleOverlayClick = () => {
  if (props.closeOnOverlayClick) {
    closeModal()
  }
}

const handleInput = () => {
  emit('input', inputValue.value)
}

const deleteHandler = () => {
  emit('deleteFolder')
}

const submitHandler = () => {
  emit('submit', inputValue.value)
}

const handleComplete = (value: string) => {
  emit('complete', value)
}

const submitModalConfirm = () => {
  emit('submitModalConfirm')
}

const handleFormSubmit = (e: Event) => {
  e.preventDefault()
  if (displayValue.value.length === 6) {
    handleComplete(displayValue.value)
  }
}

// watchers

watch(
  () => props.defaultValue,
  (newValue) => {
    inputValue.value = newValue
  },
  { immediate: true }
)

watch(
  () => props.modelValue,
  (newValue) => {
    if (!newValue && isClosing.value) {
      isClosing.value = false
    }
  },
  { immediate: true }
)

watch(() => props.modelValue,
  (newValue) => {
    if (newValue) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
      if (props.showOtpInput) {
        displayValue.value = ''
      }
    }
  })
</script>

<style scoped>
/* Modal: enter 220ms ease-out (scale 0.95 → 1), exit faster for responsiveness.
   Modals stay centered — they are not anchored to a trigger. */
.modal-fade-enter-active {
  transition: opacity 220ms var(--ease-out);
}
.modal-fade-leave-active {
  transition: opacity 150ms var(--ease-in);
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

.modal-fade-enter-active>div {
  transition: transform 220ms var(--ease-out);
  will-change: transform;
}
.modal-fade-leave-active>div {
  transition: transform 150ms var(--ease-in);
}

.modal-fade-enter-from>div {
  transform: scale(0.95);
}

.modal-fade-leave-to>div {
  transform: scale(0.97);
}

:deep(.otp-input-container) {
  max-width: 190px;
}

.otp-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  direction: ltr;
  padding: 0;
  max-width: 160px !important;
  margin: 0 auto;
}

:deep(.otp-input) {
  width: 32px !important;
  max-width: 32px !important;
  height: 40px !important;
  font-size: 16px !important;
  border: 0 none !important;
  appearance: none !important;
  text-align: center !important;
  transition: all 0.2s !important;
  background: transparent !important;
  border-bottom: 2px solid #9E9E9E !important;
  margin: 0 !important;
  direction: ltr !important;
  padding: 0 !important;
  border-radius: 0 !important;
  max-width: 32px !important;
}

.otp-input:focus {
  outline: 0 none !important;
  border-bottom-color: #FC8310 !important;
  box-shadow: none !important;
}

.otp-input:disabled {
  background-color: transparent !important;
  cursor: not-allowed !important;
}

.otp-input::-webkit-outer-spin-button,
.otp-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.otp-input[type=number] {
  -moz-appearance: textfield;
  appearance: textfield;
}
</style>
